/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Chatbot from './icon-chatbot.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Chatbot {...validProps} />;
}
SvgComponent.iconName = 'chatbot';

export const ChatbotIcon = svgIconWrapper(SvgComponent);
